import * as signalR from "@microsoft/signalr";

class SignalRService {
  constructor() {
    this.connection = null;
    this.isConnected = false;
    this.listeners = new Map();
  }

  async startConnection(userId) {
    if (this.connection && this.isConnected) {
      console.log("SignalR connection already established");
      return;
    }

    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}`;
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(`${apiUrl}/hubs/notification`, {
        accessTokenFactory: () => {
          // If you have authentication token
          return localStorage.getItem("token") || "";
        },
        // Optional: Pass userId as query string if not using JWT
        // This helps the server identify the user
        ...(userId && !localStorage.getItem("token") && {
          query: { userId: userId.toString() }
        })
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    try {
      await this.connection.start();
      this.isConnected = true;
      console.log("SignalR Connected");

      // Setup notification listeners
      this.connection.on("ReceiveNotification", (notification) => {
        console.log("New notification received:", notification);
        this.notifyListeners("newNotification", notification);
      });

      this.connection.on("NotificationRead", (data) => {
        console.log("Notification marked as read:", data);
        this.notifyListeners("notificationRead", data);
      });

      this.connection.on("UnreadCountUpdated", (count) => {
        console.log("Unread count updated:", count);
        this.notifyListeners("unreadCountUpdated", count);
      });

      // Optional: Send a test message to verify connection (remove in production)
      if (process.env.NODE_ENV === 'development') {
        await this.testConnection(userId);
      }

    } catch (error) {
      console.error("SignalR Connection Error:", error);
      this.isConnected = false;
    }
  }

  // Optional test method - remove in production
  async testConnection(userId) {
    try {
      if (userId) {
        await this.connection.invoke("SendTestToSelf", parseInt(userId));
        console.log("Test notification sent to self");
      }
    } catch (error) {
      console.warn("Test notification failed (method might not exist on server):", error);
    }
  }

  async stopConnection() {
    if (this.connection) {
      try {
        await this.connection.stop();
        this.isConnected = false;
        console.log("SignalR Disconnected");
      } catch (error) {
        console.error("Error stopping SignalR connection:", error);
      }
    }
  }

  addListener(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    this.listeners.get(event).push(callback);
  }

  removeListener(event, callback) {
    if (this.listeners.has(event)) {
      const callbacks = this.listeners.get(event).filter(cb => cb !== callback);
      this.listeners.set(event, callbacks);
    }
  }

  notifyListeners(event, data) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).forEach(callback => callback(data));
    }
  }
}

export default new SignalRService();